import { Icon } from '@dixa/lib-shared-habla';
import { convertChannelCasing } from 'lib-shared-api-utils';
import { ConversationsChannels } from 'lib-shared-legacy-types';
import { ComponentProps } from 'react';

import { channelAttributes } from 'utils/channels';

type ConversationChannelIconProps = {
  channel: ConversationsChannels;
} & Partial<ComponentProps<typeof Icon>>;

export const ConversationChannelIcon = ({
  channel,
  ...iconProps
}: ConversationChannelIconProps): JSX.Element => (
  <Icon
    {...iconProps}
    name={
      channelAttributes[convertChannelCasing(channel, 'snake')]?.icon || 'chat'
    }
  />
);
